import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceSummaryComponent } from 'src/app/main/service/service-summary/service-summary.component';
import { ToolbarButton } from '../../../models/toolbar-button/toolbar-button';

const routes: Routes = [
  {
    path: ':serviceId',
    component: ServiceSummaryComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceSummaryRoutingModule {

}
